import { Helper } from '../Helper';
export class DidSendAssetsHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitSysCall(node, 'System.ExecutionEngine.GetScriptContainer');
        sb.emitSysCall(node, 'Neo.Transaction.GetReferences');
        sb.emitHelper(node, options, sb.helpers.arrSome({
            map: () => {
                sb.emitSysCall(node, 'Neo.Output.GetScriptHash');
                sb.emitSysCall(node, 'System.ExecutionEngine.GetExecutingScriptHash');
                sb.emitOp(node, 'EQUAL');
            },
        }));
        if (!optionsIn.pushValue) {
            sb.emitOp(node, 'DROP');
        }
    }
}

//# sourceMappingURL=DidSendAssetsHelper.js.map
